<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="bmTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true">
              {{ $t("apps.ghistory") }}
            </button>
          </li>
        </ul>

        <div id="bmTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("apps.ghistory") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="group_search" @change="shoplist">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="shop_search" :disabled="group_search === ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input type="text" v-model="tk_search" :disabled="shop_search === ''" />
                  </div>

                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.stockno") }}</label>
                    <material-input type="text" v-model="stockno_search" :disabled="shop_search === ''" />
                  </div>

                  <div class="row mt-4">
                    <div class="col-3 d-flex justify-content-between align-items-center"></div>
                    <div class="col-9 d-flex justify-content-end align-items-center">
                      <div class="me-3">
                        <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                          @click="loadDataHistoryApi"
                          :disabled="(group_search === '' || shop_search === '') || (tk_search === '' && stockno_search === '')">
                          <i class="material-icons material-symbols-outlined">search</i>
                          {{ search }}
                        </material-button>
                      </div>
                      <div class="me-3">
                        <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                          @click="cancelBtn">
                          <i class="material-icons material-symbols-outlined">close</i>
                          {{ cancel }}
                        </material-button>
                      </div>
                    </div>
                  </div>

                  <hr />
                  <div class="row mt-3">
                    <div class="table-responsive">
                      <table class="table table-flush">
                        <thead class="thead-light">
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.dant") }}</th>
                            <th>{{ $t("content.names") }}</th>
                            <th>{{ $t("content.amnticketold") }}</th>
                            <th>{{ $t("content.ticketno") }}</th>
                            <th>{{ $t("content.stockno") }}</th>
                            <th>{{ $t("content.migraref") }}</th>
                            <th>{{ $t("content.amnbiz") }}</th>
                            <th>{{ $t("content.allweight") }}</th>
                            <th>{{ $t("content.allqty") }}</th>
                            <th>{{ $t("content.amnpawnvalall") }}</th>
                            <th>{{ $t("content.amnreceiveprofit") }}</th>
                            <th>
                              {{ $t("content.actpawn3") }} /
                              {{ $t("content.actpawn4") }}
                            </th>
                            <th>{{ $t("content.gpay") }}</th>
                            <th>{{ $t("content.amnchannel") }}</th>
                            <th>{{ $t("content.assessor") }}</th>
                            <th>{{ $t("content.status") }}</th>
                            <th>{{ $t("content.act") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in listhistory" :key="index"
                            :class="row.status !== 'TERMINATE' ? '' : 'bg-working'">
                            <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                              index + 1) }}</td>
                            <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                            <td class="text-sm font-weight-normal">
                              <span v-if="row.changeName">
                                {{ row.cusName }}
                              </span>
                              <span v-else>
                                {{ row.tkCusName }}
                              </span>
                            </td>
                            <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                            <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                            <td class="text-sm font-weight-normal">{{ row.stockNumber }}</td>
                            <td class="text-sm font-weight-normal text-center">{{ row.migrateRefNumber }}</td>
                            <td class="text-sm font-weight-normal" :style="row.outage ? 'color:red' : ''">
                              <span v-if="row.represent">
                                <span v-if="row.migration">
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                  </span>
                                  <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน{{checkOutage(',',row.outage)}})
                                  </span>
                                </span>
                                <span v-else>
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} (ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                  </span>
                                  <span v-else>
                                    {{ checkTransaction(row.type) }} (ทำแทน{{checkOutage(',',row.outage)}})
                                  </span>
                                </span>
                              </span>
                              <span v-else-if="row.shopRepresent">
                                <span v-if="row.migration">
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                  </span>
                                  <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                  </span>
                                </span>
                                <span v-else>
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                  </span>
                                  <span v-else>
                                    {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                  </span>
                                </span>
                              </span>
                              <span v-else-if="row.changeName">
                                <span v-if="row.migration">
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                      {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                  }},เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                  </span>
                                  <span v-else>
                                      {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                  }},เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                  </span>
                                </span>
                                <span v-else>
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                  </span>
                                  <span v-else>
                                    {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                  </span>
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="row.migration">
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                  </span>
                                  <span v-else>
                                      {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkOutage(',',row.outage)}})
                                  </span>
                                </span>
                                <span v-else>
                                  <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                  </span>
                                  <span v-else>
                                      {{ checkTransaction(row.type) }} {{checkOutage('-',row.outage)}}
                                  </span>
                                </span>
                              </span>
                            </td>
                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                            <td class="text-sm font-weight-normal">
                              {{ formatNumberDecimalString(row.pawnValue) }}
                            </td>
                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}
                            </td>
                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.diffValue) }}</td>
                            <td class="text-sm font-weight-normal">
                              {{ formatNumberDecimalString(row.payOrReceive) }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              <span v-if="row.channel === 'SHOP'">
                                {{ $t("content.gchshop") }}
                              </span>
                              <span v-else>
                                LINE OA
                              </span>
                            </td>
                            <td class="text-sm font-weight-normal">{{ row.managerName }}</td>
                            <td class="text-sm font-weight-normal text-center">
                              {{ checkProcess(row.status) }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              <material-button color="info" variant="outline" class="rounded-circle"
                                :title="t('buttons.seed')" @click="openDetail(row)">
                                <i class="material-icons material-symbols-outlined">visibility</i>
                              </material-button>
                              <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                                data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                              </material-button>
                              <material-button color="secondary" variant="outline" class="rounded-circle"
                                title="ดู Info" @click="openInfo(row)">
                                <i class="material-icons material-symbols-outlined">data_object</i>
                              </material-button>
                              <material-button variant="outline" class="rounded-circle" v-show="false"
                                data-bs-toggle="modal" data-bs-target="#workcaseInfoModal" id="workcaseInfo">
                              </material-button>

                            </td>
                          </tr>
                          <tr v-if="listhistory.length === 0">
                            <td colspan="16" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="group-sub-header">
                            <td class="text-lg font-weight-bold text-end text-center" colspan="8">
                              <span v-if="listhistory.length > 0">
                                <b>{{ $t("content.gtotal") }}</b>
                              </span>
                            </td>
                            <td class="text-lg font-weight-bold">
                              <span v-if="listhistory.length > 0">
                                <b>{{ formatNumberDecimalString(totalWeight) }}</b>
                              </span>
                            </td>
                            <td class="text-lg font-weight-bold">
                              <span v-if="listhistory.length > 0">
                                <b>{{ formatNumberString(totalQuantity) }}</b>
                              </span>
                            </td>

                            <td class="text-lg font-weight-bold">
                              <span v-if="listhistory.length > 0">
                                <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                              </span>
                            </td>
                            <td class="text-lg font-weight-bold">
                              <span v-if="listhistory.length > 0">
                                <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                              </span>
                            </td>
                            <td class="text-lg font-weight-bold" colspan="5"></td>
                            <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <pre></pre>
                  <div style="display: flex; justify-content: flex-end">
                    <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                      <div class="project-container">
                        <div class="example-one">
                          <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                            @click="onClickHandler" />
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>



            <!-- Detail Modal -->
            <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                      <i class="material-icons material-symbols-outlined">close</i>
                    </button>
                  </div>

                  <div class="modal-body">

                    <div class="row">
                      <div class="col-lg-6 mt-2">
                        <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false"
                          style="max-width: 520px">
                          <div class="carousel-indicators" id="demo1">
                          </div>
                          <div class="carousel-inner">
                            <ul className="list-unstyled">
                              <li v-for="(item, index) in images.length" :key="index">
                                <span v-if="index === 0">
                                  <div class="carousel-item active">
                                    <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                      class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                      message-pos="top" />
                                  </div>
                                </span>
                                <span v-else>
                                  <div class="carousel-item">
                                    <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                      class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                      message-pos="top" />
                                  </div>
                                </span>
                              </li>
                            </ul>
                          </div>
                          <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                          </button>
                          <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-6 mt-2">
                        <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                          <div>
                            <table class="table table-sm table-borderless">
                              <tbody>
                                <tr>

                                  <td class="fs-14 text-bold">{{ $t("content.ticketno") }} :
                                    <span v-if="workcaseDetail.tkRefNumber !== ''">
                                      {{ workcaseDetail.tkRefNumber }} &nbsp;
                                      <span @click='copyBtn()' style="cursor: pointer">
                                        <i class="inline-icon material-icons">content_copy</i>
                                      </span>
                                    </span>
                                    <span v-else>-</span>
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }} :
                                    <span v-if="workcaseDetail.deposit" style="color:green;">
                                      {{ $t("content.stdeposittk") }} ({{ dep_ref }})
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>

                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                                    {{ checkTransaction(workcaseDetail.transactionType) }}
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.statusticket") }} :
                                    <span v-if="workcaseDetail.status === 'FINISH'" style="color:green;">
                                      {{ tk_status }}
                                    </span>
                                    <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                                      || workcaseDetail.status === 'BREAKING'" style="color:red;">
                                      <span v-if="workcaseDetail.status === 'BREAKING'">
                                        {{ tk_status }} ({{ format_date(workcaseDetail.breakingDate) }} : {{
                                          workcaseDetail.lotNumber }})
                                      </span>
                                      <span v-else>
                                        {{ tk_status }}
                                      </span>
                                    </span>
                                    <span v-else>
                                      {{ tk_status }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-if="workcaseDetail.postponeCount === 0">
                                  <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }} : {{
                                    format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                                  <td class="fs-14 text-bold">
                                    {{ $t("content.amnduedate") }} :
                                    <span style="color:red;">
                                      {{ format_date(workcaseDetail.dueDate) }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-if="workcaseDetail.postponeCount !== 0">
                                  <td class="fs-14 text-bold" colspan="2"> {{ $t("content.lasttrf") }} : {{
                                    format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                                </tr>
                                <tr v-if="workcaseDetail.postponeCount !== 0">
                                  <td class="fs-14 text-bold" colspan="2">
                                    {{ $t("content.amnduedate") }} :
                                    <span style="color:red;">
                                      {{ format_date(workcaseDetail.dueDate) }} (ขอเลื่อนเป็นวันที่ {{
                                        format_date(workcaseDetail.postponeDate) }})
                                    </span>
                                  </td>
                                </tr>
                                <tr v-if="workcaseDetail.postponeCount !== 0">
                                  <td class="fs-14 text-bold" colspan="2">
                                    {{ $t("content.deferpast") }} :
                                    <span @click='NewTab()' style="text-decoration: underline;color:red; cursor: pointer">
                                      {{ workcaseDetail.postponeCount }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">
                                    {{ $t("content.monthlyprofn") }} : {{
                                      formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                                    <span style="color:red;">
                                      ({{ format_date(new Date()) }})
                                    </span>
                                  </td>
                                  <td class="fs-14 text-bold">
                                    {{ $t("content.currentprof") }} :
                                    <span style="color:red;">
                                      {{ formatNumberDecimalString(int_cal) }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">
                                    {{ $t("content.prointerestn") }} :
                                    <span
                                      v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                                      -
                                    </span>
                                    <span style="color:blue;" v-else>
                                      {{ formatNumberDecimalString(workcaseDetail.interestPromotion) }}
                                    </span>
                                  </td>
                                  <td class="fs-14 text-bold">
                                    {{ $t("content.periodpromotion") }} :
                                    <span v-if="workcaseDetail.promotionDuration === 0">
                                      -
                                    </span>
                                    <span style="color:blue;" v-else>
                                      {{ workcaseDetail.promotionDuration }} เดือน
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">{{ $t("content.periodpawnn") }} :
                                    <span style="color:blue;">
                                      {{ int_period }} เดือน
                                    </span>
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.amnbookno") }}
                                    <span style="color:blue;">
                                      {{ workcaseDetail.tkVolNo }}
                                    </span>
                                    &nbsp;{{ $t("content.amnno") }}
                                    <span style="color:blue;">
                                      {{ workcaseDetail.tkNo }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">{{ $t("content.amnqtypiece") }} :
                                    {{ formatNumberString(workcaseDetail.ticket.totalQuantity) }}
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.allweight") }} :
                                    {{ formatNumberDecimalString(workcaseDetail.ticket.totalWeight) }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">{{ $t("content.pawnvalpv") }} :
                                    <span v-if="workcaseDetail.transactionType === 'PAWN'">
                                      {{ formatNumberDecimalString(0) }}
                                    </span>
                                    <span v-else>
                                      {{ formatNumberDecimalString(workcaseDetail.pawnValue) }}
                                    </span>
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }}
                                    :
                                    {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">{{ $t("content.amnanalysval") }} :
                                    {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.amnmaxvalall") }} :
                                    {{ formatNumberDecimalString(workcaseDetail.ticket.totalFullValue) }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold">{{ $t("content.statusticketlost") }} :
                                    <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> ไม่มี
                                    </span>
                                    <span v-else style="color:red;">
                                      มี ({{ workcaseDetail.lostCount }})
                                    </span>
                                  </td>
                                  <td class="fs-14 text-bold">{{ $t("content.refnolost") }} :
                                    <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> -
                                    </span>
                                    <span v-else style="color:red;">
                                      {{ workcaseDetail.lostRefNumber }}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-if="workcaseDetail.represent || workcaseDetail.shopRepresent">
                                  <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                                    <span style="color:red;">
                                      {{workcaseDetail.customerInfo.name}}
                                    </span>
                                  </td>
                                </tr>
                                <tr v-if="workcaseDetail.changeName">
                                  <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bf_changename }}) :
                                      <span style="color:red;">
                                        {{ af_changename }}
                                      </span>
                                  </td>
                                </tr>
                                <tr>
                                    <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                                      <span v-if="workcaseDetail.outage" style="color:red">
                                        {{ $t("content.yes") }}
                                      </span>
                                      <span v-else style="color:green">
                                        {{ $t("content.no") }}
                                      </span>
                                    </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold" colspan="2"> {{ $t("content.amnlocationasset") }} :
                                    <span v-if="workcaseDetail.ticket.locationName !== null">
                                      {{ workcaseDetail.ticket.locationName }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>

                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold" colspan="2"> {{ $t("content.stockno") }} :
                                    <span v-if="workcaseDetail.ticket.stockNumber !== null">
                                      {{ workcaseDetail.ticket.stockNumber }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>

                                  </td>
                                </tr>
                                <tr>
                                  <td class="fs-14 text-bold" colspan="2"> {{ $t("content.migraref") }} :
                                    <span v-if="workcaseDetail.migrateRefNumber !== null">
                                      {{ workcaseDetail.migrateRefNumber }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>

                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <span v-if="listinfo.length !== 0">
                              <table class="table table-sm table-borderless" 
                                    style="width: 100%; table-layout: fixed; border-collapse: collapse; border: 0 !important;">
                                
                                <colgroup>
                                  <col style="width: auto;">
                                  <col style="width: 160px;"> <!-- ปรับตามความยาวตัวเลข -->
                                </colgroup>

                                <!-- เพิ่ม style ลบ border ที่ tbody เพื่อความชัวร์ -->
                                <tbody style="border: 0 !important;">
                                  <tr>
                                    <!-- ลบ border-top แบบเจาะจงที่ตัว td หัวข้อ -->
                                    <td colspan="2" class="fs-14 text-bold" 
                                        style="border: 0 !important; border-top: 0 !important; padding-top: 15px;">
                                      <span style="text-decoration:underline;">
                                        {{ $t("content.amnassetdetail") }}
                                      </span>
                                    </td>
                                  </tr>

                                  <tr v-for="(row, index) in listinfo" :key="index">
                                    <td class="fs-14 text-bold" 
                                        style="word-break: break-word; white-space: normal; vertical-align: top; text-align: left; padding-right: 5px; border: 0 !important;">
                                      {{ formatNumberString(index + 1) }}. {{ row.remark }}
                                    </td>
                                    <td class="fs-12 text-bold" 
                                        style="vertical-align: top; text-align: right; white-space: nowrap; border: 0 !important;">
                                      <span style="color:blue;">
                                        {{ formatNumberDecimalString(row.newPawnValue) }} 
                                      </span> / {{ formatNumberDecimalString(row.fullValue) }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </span>
                            <span v-else>
                              <tr>
                                <td class="fs-14 text-bold">
                                  <span style="text-decoration:underline;">
                                    {{ $t("content.amnassetdetail") }}
                                  </span>
                                  : -
                                </td>

                              </tr>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr v-if="paymentE !== ''" />
                    <div class="col-12 mt-2" v-if="paymentE !== ''">
                      <div class="fs-14 text-bold">
                        <span style="text-decoration:underline;">
                          {{ $t("content.amnfinanceinfo") }}
                        </span>
                      </div>
                      <pre></pre>
                      <div class="row">
                        <div class="table-responsive">
                          <table class="table table-flush">
                            <thead class="thead-light">
                              <tr>
                                <th>#</th>
                                <th>{{ $t("content.ticketno") }}</th>
                                <th>{{ $t("content.amnbiz") }}</th>
                                <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    {{ $t("content.amnincome") }}
                                  </span>
                                </th>
                                <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                                  <span style="color:black;">
                                    {{ $t("content.amnoutcome") }}
                                  </span>
                                </th>
                                <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                                  <span style="color:black;">
                                    {{ $t("content.fee") }}
                                  </span>
                                </th>
                              </tr>
                              <tr>
                                <th colspan="3"></th>
                                <th class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    {{ $t("content.amncash") }}
                                  </span>
                                </th>
                                <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    {{ $t("content.amnbanktransfer") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    {{ $t("content.amncreditcard") }}
                                  </span>

                                </th>
                                <th class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    {{ $t("content.amncheque") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#fecac7;">
                                  <span style="color:black;">
                                    {{ $t("content.amncash") }}
                                  </span>
                                </th>
                                <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                                  <span style="color:black;">
                                    {{ $t("content.amnbanktransfer") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#CFEBFD;">
                                  <span style="color:black;">
                                    {{ $t("content.amncash") }}
                                  </span>
                                </th>
                                <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                                  <span style="color:black;">
                                    {{ $t("content.amnbanktransfer") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#CFEBFD;">
                                  <span style="color:black;">
                                    {{ $t("content.amncreditcard") }}
                                  </span>
                                </th>
                              </tr>
                              <tr>
                                <th colspan="3"></th>
                                <th style="background-color:#dfffdd;"></th>
                                <th class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    {{ $t("content.amnbankacc") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#dfffdd;">
                                  <span style="color:black;">
                                    QR Code
                                  </span>
                                </th>
                                <th colspan="2" style="background-color:#dfffdd;"></th>
                                <th style="background-color:#fecac7;"></th>
                                <th class="align-top text-center" style="background-color:#fecac7;">
                                  <span style="color:black;">
                                    {{ $t("content.amnbankacc") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#fecac7;">
                                  <span style="color:black;">
                                    {{ $t("content.amntransfer_promt_mobile") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#fecac7;">
                                  <span style="color:black;">
                                    {{ $t("content.amntransfer_promt_taxid") }}
                                  </span>
                                </th>
                                <th style="background-color:#CFEBFD;"></th>
                                <th class="align-top text-center" style="background-color:#CFEBFD;">
                                  <span style="color:black;">
                                    {{ $t("content.amnbankacc") }}
                                  </span>
                                </th>
                                <th class="align-top text-center" style="background-color:#CFEBFD;">
                                  <span style="color:black;">
                                    QR Code
                                  </span>
                                </th>
                                <th style="background-color:#CFEBFD;"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, index) in paymentE.workCases" :key="index">
                                <template v-if="row.ticket !== null">
                                  <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                                  </td>
                                  <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                                  <td class="text-sm font-weight-normal text-center">{{
                                    checkTransaction(row.transactionType) }}</td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[0].receive > 0" style="color:green;">
                                      {{ formatNumberDecimalString(payment_l[0].receive) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[1].receive > 0" style="color:green;">
                                      {{ formatNumberDecimalString(payment_l[1].receive) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[6].receive > 0" style="color:green;">
                                      {{ formatNumberDecimalString(payment_l[6].receive) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[2].receive > 0" style="color:green;">
                                      {{ formatNumberDecimalString(payment_l[2].receive) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[3].receive > 0" style="color:green;">
                                      {{ formatNumberDecimalString(payment_l[3].receive) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[0].pay > 0" style="color:red;">
                                      {{ formatNumberDecimalString(payment_l[0].pay) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[1].pay > 0" style="color:red;">
                                      {{ formatNumberDecimalString(payment_l[1].pay) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[4].pay > 0" style="color:red;">
                                      {{ formatNumberDecimalString(payment_l[4].pay) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[5].pay > 0" style="color:red;">
                                      {{ formatNumberDecimalString(payment_l[5].pay) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[0].fee > 0" style="color:blue;">
                                      {{ formatNumberDecimalString(payment_l[0].fee) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[1].fee > 0" style="color:blue;">
                                      {{ formatNumberDecimalString(payment_l[1].fee) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[6].fee > 0" style="color:blue;">
                                      {{ formatNumberDecimalString(payment_l[6].fee) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                  <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                    :rowspan="paymentE.workCases.length">
                                    <span v-if="payment_l[2].fee > 0" style="color:blue;">
                                      {{ formatNumberDecimalString(payment_l[2].fee) }}
                                    </span>
                                    <span v-else>
                                      -
                                    </span>
                                  </td>
                                </template>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <!-- Workcase Info Dialog -->
            <div id="workcaseInfoModal" class="modal fade" tabindex="-1" aria-labelledby="workcaseInfoModalLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">
                      Workcase Info
                    </h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                      id="closeWorkcaseInfo">
                      <i class="material-icons material-symbols-outlined">close</i>
                    </button>
                  </div>

                  <div class="modal-body">
                    <fieldset>
                      <div class="grid-containerP" v-if="images.length > 0">
                        <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                          <td>
                            <div class="wrapper">
                              <figure width="100px" height="100px">
                                <label class="form-label ms-0">{{ item.title }}
                                  <img :src="item.src" class="img img-fluid" />
                                </label>
                              </figure>
                            </div>
                          </td>
                        </div>
                      </div>
                      <pre v-if="images.length > 0"></pre>
                      <hr v-if="images.length > 0" />
                      <pre>{{ JSON.stringify(workcaseInfo, null, 2) }}</pre>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import Modal from 'bootstrap/js/dist/modal';
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, onUpdated } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';

import moment from 'moment'
import noImg from "@/assets/img/noimg.png"


import { useWorkCaseStore } from '@/stores/workcase'
import { useCategoryStore } from '@/stores/category'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDocumentStore } from '@/stores/document'
import { useShopStore } from '@/stores/shop'
import { useGroupStore } from "@/stores/group";
import { useDepositStore } from '@/stores/deposit'


const storewc = useWorkCaseStore()
const storec = useCategoryStore()
const storei = useInterestStore()
const storep = usePaymentGroupStore()
const storedoc = useDocumentStore()
const storesh = useShopStore()
const storegr = useGroupStore()
const storedepo = useDepositStore()



const { t } = useI18n();
const swal = inject("$swal");

const cancel = computed(() => t("buttons.canc"));
const search = computed(() => t("buttons.sear"));


const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();


const group_search = ref('');
const shop_search = ref('');
const tk_search = ref('');
const stockno_search = ref('');



const listprint = ref([]);
const listhistory = ref([]);
const listgroup = ref([]);
const listshop = ref([]);

const listinfo = ref([]);
const info_cat = ref('');
const workcaseDetail = ref(null);
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const int_period = ref('');
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');


const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const loading = ref(false);
const workcaseInfo = ref(null);

const totalQuantity = ref(0);
const totalPawnValue = ref(0);
const totalWeight = ref(0);
const totalInterest = ref(0);

const onClickHandler = (page) => {
  updatePagination()
};

const loadgroupListApi = async (val) => {
  listgroup.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
  };
  const payload = data;
  // console.log("loadgroupListApi p : " + JSON.stringify(payload));
  const response = await storegr.groupListFetch(payload);
  // console.log("loadgroupListApi r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listgroup.value = response.data.data.list;
      }
    }
  }
}

loadgroupListApi();

const loadDataPrintApi = async () => {
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
      }
    }
  }
}

loadDataPrintApi();

async function shoplist() {
  listshop.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: group_search.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop.value = response.data.data.list;
      }
    }
  }
}


function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}


function cancelBtn() {
  tk_search.value = '';
  currentPage.value = 1
  listhistory.value = []
  totalRows_s.value = ''
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  stockno_search.value = ''
  group_search.value = ''
  shop_search.value = ''
}


const loadDataHistoryApi = async () => {
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  let data = "";

  if (tk_search.value || stockno_search.value !== '') {
    currentPage.value = 1
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: '',
    refNumber: tk_search.value.trim(),
    fromDate: '',
    toDate: '',
    type: '',
    serialNumber: '',
    shopUid: shop_search.value,
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: stockno_search.value.trim(),
    groupUid: group_search.value,
    active: false,
    channel: "",
    catUid: '',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
  };

  const payload = data;
  // console.log("History p : " + JSON.stringify(payload));
  const response = await storewc.workCaseHistoryFetch(payload);
  // console.log("History r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


async function getworkCaseInfo(id) {
  let data = "";
  data = {
    groupUid: group_search.value,
    shopUid: shop_search.value,
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}

async function calIntInt() {
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  data = {
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: workcaseDetail.value.newPawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}


async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    groupUid: group_search.value,
    shopUid: shop_search.value,
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupInfoAdminFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function checkProcess(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'เสร็จสิ้น'
  } else if (str === 'ACTIVE') {
    side = 'กำลังดำเนินการ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'TERMINATE') {
    side = 'ยกเลิก'
  } else if (str === 'BREAKING') {
    side = 'ของหลุด'
  }
  return side
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}

function containsOnlyNumbers(str){
  return /^\d+$/.test(str);
}

function checkOutage(str,val) { 
  let side = ''
  if (val) {
    if (str === ',') {
      side = str + t("content.outage")
    } else  if (str === '-') {
      side = '('+t("content.outage") + ')'
    }
    
  }
  return side
}

function checkShopRepresent(str,item) { 
  let side = ''
  if (item.outage === false) {
    if (str === ',') {
      side = str + t("content.gchonline")
    } else if (str === '-') {
      side = '(' + t("content.gchonline")
    }
  }

  
  if (containsOnlyNumbers(item.initRefNumber)) {
    if (side === '') {
      if (str === ',') {
          side = ','+t("content.translost")
        } else if (str === '-') {
          side = '('+t("content.translost")
        }
    } else {
      side = side + ','+t("content.translost")
    }
  }

  if (item.outage) {
      if (side === '') {
        if (str === ',') {
            side = str + t("content.outage")
          } else if (str === '-') {
            side = '(' + t("content.outage")
          }
      } else {
        side =  side + ','+t("content.outage")
      }
    }

  if (side !== '' && str === '-') {
    side = side + ')'
  }  

  return side
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}


async function updatePagination() {
  listhistory.value = []
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0

  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: '',
    refNumber: tk_search.value.trim(),
    fromDate: '',
    toDate: '',
    type: '',
    serialNumber: '',
    shopUid: shop_search.value,
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: stockno_search.value.trim(),
    groupUid: group_search.value,
    active: false,
    channel: "",
    catUid: '',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
  };

  const payload = data;
  const response = await storewc.workCaseHistoryFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


function setGallery() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo1").innerHTML = y;
}


async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  info_cat.value = ''
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {
    loading.value = true
    if (workcaseDetail.value.changeName) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }
    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      await calIntInt();
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      setGallery()
      document.getElementById("detailModal").click();
      loading.value = false
    }
  } else {
    loading.value = false
  }
}


async function getTicketImage() {
  images.value = []
  for (let i = 0; i < images_l.value.length; i++) {
    if (images_l.value[i].imageUid !== "0") {
      await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid, '')
    }
  }
  if (images.value.length > 0) {
    setGallery()
    document.getElementById("detailModal").click();
    loading.value = false
  } else {
    let obj = {
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    }
    images.value.push(obj)
    setGallery()
    document.getElementById("detailModal").click();
    loading.value = false
  }
}

async function getFileImg(imageUid, uid, title) {
  let data = "";
  data = {
    shopUid: shop_search.value,
    uid: imageUid,
  };
  const payload = data;
  // console.log('fi p : ' + JSON.stringify(payload));
  const response = await storedoc.imgAdminInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('fi r : ' + JSON.stringify(response.data));
        const file = getFileFromBase64(response.data.data.data, response.data.data.name)
        const data = URL.createObjectURL(file);
        let obj = {
          src: data,
          thumbnailImageSrc: data,
          alt: '',
          title: title,
          uid: uid,
          imageUid: imageUid,
        }
        images.value.push(obj)
      }
    }
  }
}


function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


async function openInfo(item) {
  loading.value = true
  workcaseInfo.value = null
  images.value = []
  images_l.value = []
  let data = "";
  data = {
    groupUid: group_search.value,
    shopUid: shop_search.value,
    uid: item.uid,
  };
  const payload = data;
  // console.log('wc p : ' + JSON.stringify(payload));
  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log('wc r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseInfo.value = response.data
        if (workcaseInfo.value !== null) {
          // console.log('wc r : ' + workcaseInfo.value.data.customerInfo.fpImageUid);
          if (workcaseInfo.value.data.customerInfo.fpImageUid !== "0") {
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: 'customerInfo',
              uid: workcaseInfo.value.data.customerInfo.fpImageUid,
              imageUid: workcaseInfo.value.data.customerInfo.fpImageUid,
            }
            images_l.value.push(obj)
          }

          if (workcaseInfo.value.data.tkCustomerInfo.fpImageUid !== "0") {
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: 'tkCustomerInfo',
              uid: workcaseInfo.value.data.tkCustomerInfo.fpImageUid,
              imageUid: workcaseInfo.value.data.tkCustomerInfo.fpImageUid,
            }
            images_l.value.push(obj)
          }
          if (workcaseInfo.value.data.rlCustomerInfo !== null) {
            if (workcaseInfo.value.data.rlCustomerInfo.fpImageUid !== "0") {
              let obj = {
                src: data,
                thumbnailImageSrc: data,
                alt: '',
                title: 'rlCustomerInfo',
                uid: workcaseInfo.value.data.rlCustomerInfo.fpImageUid,
                imageUid: workcaseInfo.value.data.rlCustomerInfo.fpImageUid,
              }
              images_l.value.push(obj)
            }
          }

          if (images_l.value.length > 0) {
            await getFingerImage()
          } else {
            document.getElementById("workcaseInfo").click();
          }
          loading.value = false
        } else {
          swal('Record not found', "", "error");
        }
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function getFingerImage() {
  images.value = []
  for (let i = 0; i < images_l.value.length; i++) {
    if (images_l.value[i].imageUid !== "0") {
      await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid, images_l.value[i].title)
    }
  }
  document.getElementById("workcaseInfo").click();
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: group_search.value,
    shopUid: shop_search.value,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: group_search.value,
    shopUid: shop_search.value,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}



onMounted(() => {
  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});


</script>

<style lang="scss" scoped>
.inline-icon {
  display: inline-flex;
  vertical-align: top;
  font-size: 20px !important;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-container {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-12 {
  font-size: 0.75rem;
}
</style>
